import {Component, ElementRef, Injector, Input, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as fromFehlerbeschreibungPage from './fehlerbeschreibung.reducer';
import * as actionsUi from './fehlerbeschreibung.actions.ui';
import {select, Store} from '@ngrx/store';
import * as apiVeranstaltungen from '../../../clients/veranstaltungen';
import {Aufgabe} from '../../../clients/veranstaltungen';
import {ImageService} from '@orga-app/providers/image.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {BildVorschauComponent} from '../../../sopi/components/bild-vorschau/bild-vorschau';
import {UploadResponse, UploadService} from '../../../clients/api';
import * as util from '@orga-app/providers/utils';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {ActivatedRoute, Router} from '@angular/router';
import {GetAufgabeFehlerAction, PostAufgabeNichtOkErfassenAction, PostFehlerbeschreibungHinzufuegenAction, PostFehlerbildEntfernenAction, PostFehlerbildHinzufuegenAction} from '../../../client-ngrx/veranstaltungen';
import {LoadingController, ModalController, Platform} from '@ionic/angular';
import {catchError, filter, takeUntil, takeWhile} from 'rxjs/operators';
import {Observable, of, Subject} from 'rxjs';
import {UuidService} from '@orga-app/providers/uuid.service';
import * as fromAppState from '../app-state/app-state.reducer';
import {getPlatform} from '../app-state/app-state.reducer';
import {BildInfo} from 'src/app/shared/models/bildInfo';
import {Camera, CameraResultType, CameraSource} from '@capacitor/camera';


@Component({
    selector: 'app-fehlerbeschreibung',
    templateUrl: './fehlerbeschreibung.page.html',
})
export class FehlerbeschreibungPage implements OnInit, OnDestroy {
    public platformState$: Observable<string>;
    public platformState: string;

    @Input() aufgabe: Aufgabe;

    public veranstaltungBerechtigung$: Observable<apiVeranstaltungen.VeranstaltungBerechtigung>;

    veranstaltungBerechtigung: apiVeranstaltungen.VeranstaltungBerechtigung;

    aufgabe$: Observable<apiVeranstaltungen.Aufgabe>;
    checkliste: apiVeranstaltungen.Checkliste;
    fehlerbeschreibung = '';
    bilder$: Observable<BildInfo[]>;
    settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    aiName = 'FehlerbeschreibungPage';
    fehler$: Observable<apiVeranstaltungen.Fehler>;
    fehlerbeschreibungGemeldet$: Observable<boolean>;
    uiZeigeFehlerbeschreibungMeldenLaden$: Observable<boolean>;
    uiZeigeFehlerbeschreibungMeldenLadefehler$: Observable<boolean>;
    editMode = false;
    editModeSub: Subject<boolean> = new Subject();
    editMode$: Observable<boolean>;
    bilder: Array<BildInfo> = new Array<BildInfo>();
    private unsubscribe$ = new Subject();
    private alive = true;
    unsubscibe$ = new Subject<void>();

    constructor(
        public platform: Platform,
        public loadingCtrl: LoadingController,
        public domSanitizer: DomSanitizer,
        public modalCtrl: ModalController,
        public injector: Injector,
        private zone: NgZone,
        public element: ElementRef,
        private imageService: ImageService,
        private uploadCommandService: UploadService,
        private store: Store<fromFehlerbeschreibungPage.PageState>,
        private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
        private settingsProvider: SettingsProvider,
        public route: ActivatedRoute,
        public router: Router,
        private uuiService: UuidService) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
        this.editModeSub.next(this.editMode);
        this.editMode$ = this.editModeSub.asObservable();
    }

    ngOnInit() {
        // Platform from State
        this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));
        this.veranstaltungBerechtigung$ = this.storeVeranstaltung.pipe(select(fromAppState.getVeranstaltungBerechtigung));

        this.fehlerbeschreibungGemeldet$ = this.store.pipe(select(fromFehlerbeschreibungPage.getFehlerbeschreibungGemeldet));
        this.uiZeigeFehlerbeschreibungMeldenLaden$ = this.store.pipe(select(fromFehlerbeschreibungPage.getUiZeigeFehlerbeschreibungMeldenLaden));
        this.uiZeigeFehlerbeschreibungMeldenLadefehler$ = this.store.pipe(select(fromFehlerbeschreibungPage.getUiZeigeFehlerbeschreibungMeldenLadefehler));
        this.fehler$ = this.store.pipe(select(fromFehlerbeschreibungPage.getFehler));
        this.aufgabe$ = this.store.pipe(select(fromFehlerbeschreibungPage.getAktuelleAufgabe));

        this.veranstaltungBerechtigung$.subscribe((x) => {
            if (x != null) {
                this.veranstaltungBerechtigung = x;
            }
        }).unsubscribe();

        this.platformState$.subscribe(x => {
            this.platformState = x;
        }).unsubscribe();

    }

    toggleEditMode() {
        this.editMode = !this.editMode;
        this.editModeSub.next(this.editMode);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.unsubscibe$ = new Subject<void>();
        await this.store.dispatch(new actionsUi.PageStateResetAction());

        await this.route.paramMap.subscribe(async params => {
            const aufgabeId = params.get('aufgabeId');
            const checklisteId = params.get('checklisteId');
            const funktionsbereichId = params.get('funktionsbereichId');
            const veranstaltungId = params.get('veranstaltungId');
            if (this.platformState !== 'desktop') {
                this.aufgabe = <apiVeranstaltungen.Aufgabe>{
                    veranstaltung_id: veranstaltungId,
                    aufgabe_id: aufgabeId,
                    checkliste_id: checklisteId,
                    funktionsbereich_id: funktionsbereichId
                };
            }

            await this.store.dispatch(new actionsUi.AktuelleAufgabeSetzenAction(this.aufgabe));
            await this.store.dispatch(new GetAufgabeFehlerAction(this.aufgabe.aufgabe_id));

            this.store.pipe(select(fromFehlerbeschreibungPage.getFehler), takeUntil(this.unsubscibe$)).subscribe((x) => {
                if (x != null) {
                    this.fehlerbeschreibung = x.beschreibung;
                    if (x.fehler_bilder_ids.length > 0) {
                        while (this.bilder.length > 0) {
                            this.bilder.pop();
                        }

                        x.fehler_bilder_ids.forEach(bildId => {

                            this.getFehlerBild(x.aufgabe_id, bildId)
                                .pipe(
                                    takeWhile(() => this.alive)
                                    , filter(image => {
                                        return !!image;
                                    }),
                                    catchError((error: any) => {
                                        return of();
                                    }),
                                )
                                .subscribe((image: BlobPart) => {
                                        const imgtype = bildId.split('.')[1];
                                        if (image) {
                                            const blob = new Blob([image]);

                                            const reader = new FileReader();
                                            reader.onload = function () {
                                                const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                                                const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                                                const bi = <BildInfo>{
                                                    bildId,
                                                    data: imgBase64JPEG,
                                                    dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                                                    type: 'image/' + imgtype
                                                };

                                                this.zone.run(() => {
                                                    this.bilder.push(bi);
                                                    this.bilder$ = of(this.bilder);
                                                });

                                            }.bind(this);

                                            reader.readAsDataURL(blob);
                                        }
                                    },
                                    error => {

                                    });
                        });
                    }
                }
            });
        }).unsubscribe();
    }

    ionViewWillLeave() {
        this.unsubscibe$.next();
        this.unsubscibe$.complete();
    }

    // async keyboardHandler(e) {
    //     // if (this.platform.is('android')) {
    //     if (e.keyboardHeight === undefined) {
    //         // hide
    //         this.zone.run(() => this.keyboardHeight = '56px');
    //     } else {
    //         // show
    //         this.zone.run(() => this.keyboardHeight = e.keyboardHeight + 'px');
    //     }
    //     // }
    // }


    async fehlerbeschreibungSenden() {
        const fehlerbeschreibungHinzufuegenRequest = <apiVeranstaltungen.AufgabeFehlerbeschreibungRequest>{
            fehlerbeschreibung: this.fehlerbeschreibung,
            funktionsbereich_id: this.aufgabe.funktionsbereich_id,
            checkliste_id: this.aufgabe.checkliste_id,
            aufgabe_id: this.aufgabe.aufgabe_id,
            veranstaltung_id: this.aufgabe.veranstaltung_id,
            zeitpunkt_utc: new Date()
        };

        // kommt aus der aufgabe page, optionale text eingaben
        if (this.veranstaltungBerechtigung.ist_aufgabe_nichtok_text_optional === true) {
            this.store.dispatch(new PostFehlerbeschreibungHinzufuegenAction(fehlerbeschreibungHinzufuegenRequest));
        } else {
            this.store.dispatch(new PostAufgabeNichtOkErfassenAction(fehlerbeschreibungHinzufuegenRequest));
        }


        if (this.platformState === 'desktop') {
            this.modalCtrl.dismiss('ok');
        } else {
            await this.router.navigate(['/veranstaltung', this.aufgabe.veranstaltung_id, 'funktionsbereiche-checklisten', 'funktionsbereich', this.aufgabe.funktionsbereich_id, 'checkliste', this.aufgabe.checkliste_id], {
                relativeTo: this.route,

            });
        }
    }

    /* fehler_bearbeiten */
    async doCamera(sourceType: CameraSource) {

        const imageData = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
            source: sourceType
        });

        const imgBase64JPEG = imageData.dataUrl;

        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Das Bild wird hochgeladen',
            translucent: true,
            backdropDismiss: false,
            keyboardClose: true
        });
        await loading.present();

        const blob: Blob = new util.ImageDataConverter(imgBase64JPEG).dataURItoBlob();

        const uploadId = `${this.uuiService.generateUUID()}.jpeg`;
        this.uploadCommandService.postUpload(blob, `veranstaltungen/${this.aufgabe.veranstaltung_id}/aufgaben/${this.aufgabe.aufgabe_id}/fehler`, uploadId).subscribe((result: UploadResponse) => {
            const fehlerbildRequest = <apiVeranstaltungen.AufgabeBildRequest>{
                aufgabe_id: this.aufgabe.aufgabe_id,
                checkliste_id: this.aufgabe.checkliste_id,
                bild_id: result.upload_id,
                funktionsbereich_id: this.aufgabe.funktionsbereich_id,
                veranstaltung_id: this.aufgabe.veranstaltung_id,
                zeitpunkt_utc: new Date()
            };
            this.store.dispatch(new PostFehlerbildHinzufuegenAction(fehlerbildRequest));

            const bi = <BildInfo>{
                bildId: result.upload_id,
                data: imgBase64JPEG,
                dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                type: 'image/jpeg'
            };
            this.bilder.push(bi);
            this.bilder$ = of(this.bilder);

            loading.dismiss();
        }, error2 => {
            // this.log.logError(error2);
            loading.dismiss();
        });
    }

    async fotoErstellen() {
        this.doCamera(CameraSource.Camera);
    }

    async fotoAuswaehlen() {
        this.doCamera(CameraSource.Photos);
    }

    getFehlerBild(aufgabeId: string, bildId: string): Observable<any> {
        return this.imageService.getAufgabeFehlerBildWithHttpInfo(aufgabeId, bildId);
    }

    async bilderAnzeigen(index = 0) {
        const imageModal = await this.modalCtrl.create({
            component: BildVorschauComponent, componentProps: {
                bilder: this.bilder$,
                initialImage: index
            }
        });
        imageModal.onDidDismiss().then(data => console.debug('FehlerPage:: bilderAnzeigen :  imageModal.onDidDismiss: ' + data));
        await imageModal.present();
    }

    async bildEntfernen(bildId: string) {
        const aufgabeBildRequest = <apiVeranstaltungen.AufgabeBildRequest>{
            aufgabe_id: this.aufgabe.aufgabe_id,
            checkliste_id: this.aufgabe.checkliste_id,
            bild_id: bildId,
            funktionsbereich_id: this.aufgabe.funktionsbereich_id,
            veranstaltung_id: this.aufgabe.veranstaltung_id,
            zeitpunkt_utc: new Date()
        };
        this.store.dispatch(new PostFehlerbildEntfernenAction(aufgabeBildRequest));
    }

    verlasseModal() {
        this.modalCtrl.dismiss();
    }
}
